import styled from 'styled-components'

import { Typography } from '@/components/ui/typography'

export const BuildingName = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})
